export default __webpack_public_path__ + "static/about-bg-mob-1f23b5e765ee9d4f434f758e5f46e35f.png";